module.exports = __webpack_public_path__ + "img/zhengjuan.79ce3d38.png";